import { Package, Truck, CheckCircle } from "lucide-react";

// Stats Component
export const StatsGrid = ({ courses }) => {
  const stats = {
    assigned: courses.filter(c => c.status === 'in_asteptare').length,
    inProgress: courses.filter(c => c.status === 'in_incarcare' || c.status === 'pe_drum').length,
    completed: courses.filter(c => c.status === 'livrat').length
  };

  return (
    <div className="grid grid-cols-3 gap-2 sm:gap-4 mb-6 px-4">
      {/* Atribuite */}
      <div className="bg-gradient-to-br from-blue-500/20 to-blue-600/10 backdrop-blur-sm rounded-2xl border border-blue-500/30 p-3 sm:p-4 text-center shadow-lg hover:shadow-xl hover:scale-105 transition-all">
        <div className="flex justify-center mb-2">
          <div className="w-10 h-10 sm:w-12 sm:h-12 bg-blue-500/30 rounded-xl flex items-center justify-center border border-blue-500/40">
            <Package className="w-5 h-5 sm:w-6 sm:h-6 text-blue-300" />
          </div>
        </div>
        <p className="text-3xl sm:text-4xl font-bold text-blue-300 mb-1 sm:mb-2">
          {stats.assigned}
        </p>
        <p className="text-xs sm:text-sm text-blue-200 font-medium">Atribuite</p>
      </div>

      {/* În curs */}
      <div className="bg-gradient-to-br from-yellow-500/20 to-yellow-600/10 backdrop-blur-sm rounded-2xl border border-yellow-500/30 p-3 sm:p-4 text-center shadow-lg hover:shadow-xl hover:scale-105 transition-all">
        <div className="flex justify-center mb-2">
          <div className="w-10 h-10 sm:w-12 sm:h-12 bg-yellow-500/30 rounded-xl flex items-center justify-center border border-yellow-500/40">
            <Truck className="w-5 h-5 sm:w-6 sm:h-6 text-yellow-300" />
          </div>
        </div>
        <p className="text-3xl sm:text-4xl font-bold text-yellow-300 mb-1 sm:mb-2">
          {stats.inProgress}
        </p>
        <p className="text-xs sm:text-sm text-yellow-200 font-medium">În curs</p>
      </div>

      {/* Completate */}
      <div className="bg-gradient-to-br from-green-500/20 to-green-600/10 backdrop-blur-sm rounded-2xl border border-green-500/30 p-3 sm:p-4 text-center shadow-lg hover:shadow-xl hover:scale-105 transition-all">
        <div className="flex justify-center mb-2">
          <div className="w-10 h-10 sm:w-12 sm:h-12 bg-green-500/30 rounded-xl flex items-center justify-center border border-green-500/40">
            <CheckCircle className="w-5 h-5 sm:w-6 sm:h-6 text-green-300" />
          </div>
        </div>
        <p className="text-3xl sm:text-4xl font-bold text-green-300 mb-1 sm:mb-2">
          {stats.completed}
        </p>
        <p className="text-xs sm:text-sm text-green-200 font-medium">Completate</p>
      </div>
    </div>
  );
};